import { ExamLevelKey } from "../interfaces/ExamDiscipline";

export const EXAM_BASE_URL = "https://abiturient.inpsycho.ru/exam/";

export const EXAM_LEVEL_ORDER: ExamLevelKey[] = ["1", "2"];

export const EXAM_LEVEL_TITLES: Record<ExamLevelKey, string> = {
  "1": "БАКАЛАВРИАТ/СПЕЦИАЛИТЕТ",
  "2": "МАГИСТРАТУРА",
};
